import { Handshake, ExternalLink } from "lucide-react";

// Text-based cards used while formal permission to display logos is being
// confirmed. Swap to logo-based cards when explicit consent is granted.
const partners = [
  {
    name: "Pearl Home Care",
    href: null,
  },
  {
    name: "Disability, Ageing and Community Care Services",
    href: null,
  },
  {
    name: "Kalinga Australia Pty Ltd",
    href: null,
  },
  {
    name: "FiloPhys",
    href: "https://filophys.com.au/",
  },
  {
    name: "Canberra Ear Clinic",
    href: "https://www.canberraearclinic.com.au/",
  },
];

export const Partners = () => {
  return (
    <section
      id="partners"
      data-testid="partners-section"
      className="relative py-20 sm:py-24 bg-[var(--ew-bg-3)]"
    >
      <div className="mx-auto max-w-6xl px-5 sm:px-8 lg:px-12">
        <div className="ew-card p-8 sm:p-12 lg:p-14">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 rounded-full bg-[var(--ew-accent)]/8 border border-[var(--ew-accent)]/20 px-4 py-1.5">
              <Handshake
                className="h-4 w-4 text-[var(--ew-accent)]"
                strokeWidth={1.75}
              />
              <span className="text-xs uppercase tracking-[0.18em] font-semibold text-[var(--ew-accent)]">
                Trusted Partners
              </span>
            </div>

            <h2 className="font-heading font-medium mt-5 text-3xl sm:text-4xl tracking-tight leading-[1.1] text-[var(--ew-text)]">
              Proudly working alongside dedicated organisations.
            </h2>

            <p className="mt-5 text-base sm:text-lg text-[var(--ew-text-2)] leading-relaxed max-w-2xl mx-auto">
              We are proud to work alongside organisations that share our
              commitment to responsive, person-centred and high-quality
              community care.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {partners.map((p, i) => {
              const isLink = Boolean(p.href);
              const Wrapper = isLink ? "a" : "div";
              const props = isLink
                ? {
                    href: p.href,
                    target: "_blank",
                    rel: "noopener noreferrer",
                  }
                : {};
              return (
                <Wrapper
                  key={p.name}
                  data-testid={`partner-${i}`}
                  {...props}
                  className={`group flex flex-col rounded-2xl bg-white border border-[#6E9C88]/20 px-6 py-6 min-h-[132px] justify-center transition-all ${
                    isLink
                      ? "hover:border-[var(--ew-sage)]/60 hover:shadow-[0_14px_40px_rgba(46,80,65,0.1)] hover:-translate-y-1 cursor-pointer"
                      : ""
                  }`}
                >
                  <div className="flex items-start justify-between gap-3">
                    <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-[var(--ew-sage)]/15 text-[var(--ew-accent)]">
                      <Handshake className="h-4 w-4" strokeWidth={1.75} />
                    </span>
                    {isLink && (
                      <ExternalLink
                        className="h-4 w-4 text-[var(--ew-text-muted)] group-hover:text-[var(--ew-accent)] transition-colors"
                        strokeWidth={1.75}
                      />
                    )}
                  </div>
                  <p className="mt-4 font-heading text-base font-semibold text-[var(--ew-text)] leading-snug">
                    {p.name}
                  </p>
                  {isLink && (
                    <p className="text-xs text-[var(--ew-text-muted)] mt-1.5">
                      Visit website
                    </p>
                  )}
                </Wrapper>
              );
            })}
          </div>

          <p className="mt-8 text-xs text-[var(--ew-text-muted)] italic text-center">
            Displayed as text-based partner cards while formal consent to
            display logos is being confirmed.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Partners;
